import React, { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { useHistory } from "react-router";
import { MaskID } from "app/modules/shared/mask/mascarasInputs";

const BuscadorPorLocal = ({ traerIdLocal }) => {
  const [idLocal, setidLocal] = useState();

  const navigate = useHistory();
  const handleId = (e) => {
    setidLocal(e.target.value);
  };

  const redirectHomePage = () => {
    navigate.push("/initialHome");
  };

  return (
    <>
      <Card className="buscador-container">
        <div className="buscador-cabecera">
          <h2>Consultar información del Local</h2>
        </div>
        <div className="buscador-body">
          <div className="buscador-identificacion">
            <FormControl sx={{ width: "100%" }} size="small" variant="outlined">
              <InputLabel htmlFor="buscador">Código Local</InputLabel>
              <OutlinedInput
                id="buscador"
                value={idLocal}
                label="Código Local"
                inputComponent={MaskID}
                onChange={handleId}
                required="true"
              />
            </FormControl>
          </div>
          <div className="buscador-botones">
            <Button variant="contained" onClick={traerIdLocal(idLocal)}>
              Buscar
            </Button>

            <Button variant="contained" onClick={redirectHomePage}>
              Cancelar
            </Button>
          </div>
        </div>
      </Card>
    </>
  );
};

export default BuscadorPorLocal;
